import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-document-sales-result-table',
  templateUrl: './document-sales-result-table.component.html',
  styleUrls: ['./document-sales-result-table.component.css']
})
export class DocumentSalesResultTableComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
